// extracted by mini-css-extract-plugin
export default {"root":"_S92K","left":"_3B1YW","left-side-item-wrapper":"_22k0T","leftSideItemWrapper":"_22k0T","right":"_3OlcK","right-side-item-wrapper":"_2oJwm","rightSideItemWrapper":"_2oJwm"};